export default __webpack_public_path__ + "static/media/EsilioBanner.ceab1877.png";